import { useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import styles from 'assets/jss/Login/loginPage';
import SignIn from 'components/Login/SignIn';

const useStyles = makeStyles(styles);

const Login = () => {
    const classes = useStyles();
    const elementRef = useRef();
    const [height, setHeight] = useState('100%');

    function updateSize() {
        setHeight(window.innerHeight);
    }

    useEffect(() => {
        updateSize();
        window.addEventListener('resize', updateSize);
        return () => {
            window.removeEventListener('resize', updateSize);
        };
    }, []);

    return (
        <Grid container>
            <Grid ref={elementRef} item xs={12} className={classes.containerForm}>
                <SignIn />
            </Grid>
        </Grid>
    );
};

export default Login;